.OutputField {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: var(--space-sm);
  border-radius: 2px;
  word-break: break-all;

  &[data-status="error"] {
    color: var(--accent-2);
    cursor: pointer;
  }

  &[data-status="warning"] svg {
    color: var(--accent-1);
  }

  svg {
    min-width: 16px;
    width: 16px;
  }

  @media (max-width: 640px) {
    width: fit-content;
    margin-left: auto;
  }
}

.Info {
  font-size: 0.75rem;
  color: var(--neutral);
  white-space: nowrap;
}

.TooltipContent {
  width: calc(var(--column-width) - var(--space-lg) - 12px);
  text-align: left;
  white-space: initial;

  @media (max-width: 640px) {
    max-width: 250px;
  }
}
